





















































































































































































































































































// @ts-ignore
import VueCal from "vue-cal";
import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import InterventionModal from "./InterventionModal.vue";
import InterventionReassignEmployeModal from "./InterventionReassignEmployeModal";
import { InterventionApi } from "../api/InterventionApi";
import moment from "moment";
import { Intervention } from "../models/Intervention";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import { RecurrenceInterventionApi } from "../api/RecurrenceInterventionApi";
import InterventionReassignDateModal from "./InterventionReassignDateModal.vue";
import InterventionControlModal from "./InterventionControlModal.vue";
import InterventionSetupModal from "./InterventionSetupModal.vue";
import { HolidaysApi } from "../api/HolidaysApi";

export default {
    name: "PlanificationInterventions",
    components: {
        InterventionReassignDateModal,
        InterventionControlModal,
        InterventionSetupModal,
        EmployeSelect,
        InterventionModal,
        InterventionReassignEmployeModal,
        VueCal,
    },
    data() {
        return {
            selectedEmploye: null,
            secondSelectedEmploye: null,
            disponibilites: {
                employe1: 0,
                employe2: 0,
            },
            events: [],
            unassignedEvents: [],
            splitDays: [
                {
                    id: 1,
                    class: "employe-1",
                    label: "Employé 1",
                    hide: true,
                },
                {
                    id: 2,
                    class: "employe-2",
                    label: "Employé 2",
                    hide: true,
                },
            ],
            stickySplitLabels: false,
            dateRange: {},
            timeCellHeight: 50,
            eventSelectionMode: false,
            reassignType: null,
            reassignInterventions: [],
            showSetupModal: false,
            showReassignModal: false,
            showReassignDateModal: false,
            showControlModal: false,
            loading: false,
            savingDefaultPlanning: false,
            pdfExporting: false,
            holidays: [],
            InterventionApi: new InterventionApi(),
            EmployeApi: new EmployeApi(),
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
            HolidaysApi: new HolidaysApi(),
            interventionModal: {
                isNew: false,
                interventionId: null,
                forceEditing: false,
            },
        };
    },
    computed: {
        isSelectedEmploye: function () {
            return this.selectedEmploye != null && this.selectedEmploye.id > 0;
        },
    },
    methods: {
        // Events callback
        onCalendarEvent(event) {
            let self = this;
            // update date range
            if (event.view === "week" || event.view === "day") {
                this.dateRange.startDateStr = moment(event.startDate).format(
                    "YYYY-MM-DD"
                );
                this.dateRange.endDateStr = moment(event.endDate).format(
                    "YYYY-MM-DD"
                );
                this.dateRange.week = moment(event.endDate).format("YYYY-W");
                this.refreshEvents();
            }
            // Scroll view
            if (event.view === "week" || event.view === "day") {
                setTimeout(function () {
                    let calendar = document.querySelector(
                        "#vuecal .vuecal__bg"
                    );
                    calendar.scrollTo({
                        top: 6 * self.timeCellHeight,
                        behavior: "smooth",
                    });
                }, 500);
            }
        },
        onEventClick(event, e) {
            if (event.background) {
                return;
            }
            if (this.eventSelectionMode) {
                let originalEvent = _.find(this.events, function (ev) {
                    return ev.intervention.id === event.intervention.id;
                });
                this.toggleEventSelection(originalEvent);
            } else {
                this.showIntervention(event, e);
            }
        },
        showIntervention(event, e) {
            let self = this;
            self.interventionModal.interventionId = null;
            setTimeout(function () {
                self.interventionModal.interventionId = event.intervention.id;
            });
            e.stopPropagation();
        },
        onEventChange({ event, originalEvent }) {
            let self = this;
        },
        onEventDragStart(e, draggable) {
            // Passing the event's data to Vue Cal through the DataTransfer object.
            e.dataTransfer.setData("event", JSON.stringify(draggable));
            e.dataTransfer.setData("cursor-grab-at", e.offsetY);
        },
        onEventDrop({ event, originalEvent, external }) {
            // If the event is external, delete it from the data source on drop into Vue Cal.
            // If the event comes from another Vue Cal instance, it will be deleted automatically in there.
            let self = this;

            let intervention = new Intervention(event.intervention);

            if (external) {
                _.remove(this.unassignedEvents, function (e) {
                    return e.intervention.id === event.intervention.id;
                });
                if (originalEvent.duration) {
                    event.end = event.start.addMinutes(
                        originalEvent.duration * 60
                    );
                } else {
                    if (intervention.duree_prevue) {
                        event.end = event.start.addMinutes(
                            intervention.duree_prevue * 60
                        );
                    } else {
                        event.end = event.start.addMinutes(60);
                    }
                }
            } else {
                let sameEventIntervention = _.find(self.events, function (e) {
                    return (
                        e.intervention &&
                        event.intervention &&
                        e.intervention.frequence !=
                            Intervention.EFrequence.Ponctuel &&
                        event.intervention.frequence !=
                            Intervention.EFrequence.Ponctuel &&
                        e.intervention.recurrence_intervention_id ==
                            event.intervention.recurrence_intervention_id &&
                        e.intervention.date_prevue_intervention ==
                            event.start.format("YYYY-MM-DD") &&
                        e.intervention.id != event.intervention.id
                    );
                });
                if (sameEventIntervention) {
                    let i = event.intervention;
                    let startTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_debut
                            ? i.horaire_debut.replace("h", ":")
                            : "08:00");
                    let endTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_fin
                            ? i.horaire_fin.replace("h", ":")
                            : "08:30");
                    _.remove(this.events, function (e) {
                        return (
                            e.intervention &&
                            e.intervention.id === event.intervention.id
                        );
                    });
                    this.events.push({
                        start: startTimeStr,
                        end: endTimeStr,
                        title: i.client ? i.client.nom : "",
                        content: i.titre,
                        class: event.class,
                        split: event.split,
                        intervention: i,
                    });
                    swal(
                        "Une intervention identique est déjà prévue ce jour",
                        "",
                        "error"
                    );
                    return false;
                }
            }

            let startDate = moment(event.start);
            let endDate = moment(event.end);
            let displayedEmployes = [];
            if (this.isSelectedEmploye) {
                displayedEmployes.push(this.selectedEmploye);
            }
            if (this.secondSelectedEmploye) {
                displayedEmployes.push(this.secondSelectedEmploye);
            }

            intervention.date_prevue_intervention =
                startDate.format("YYYY-MM-DD");
            intervention.horaire_debut = startDate.format("HH[h]mm");
            intervention.horaire_fin = endDate.format("HH[h]mm");

            let employe = <Employe>_.find(displayedEmployes, {
                id: event.split,
            });
            if (intervention.employes.length <= 1) {
                if (employe) {
                    intervention.employes = [employe];
                } else {
                    intervention.employes = [];
                }
            } else if (!_.find(intervention.employes, { id: event.split })) {
                let otherEmploye = null;
                if (this.secondSelectedEmploye) {
                    otherEmploye = _.find(displayedEmployes, function (e) {
                        return e.id != event.split;
                    });
                    if (otherEmploye) {
                        _.remove(intervention.employes, {
                            id: otherEmploye.id,
                        });
                    }
                }
                if (employe) {
                    intervention.employes.push(employe);
                }
            }

            _.remove(this.events, function (e) {
                return (
                    e.intervention &&
                    e.intervention.id === event.intervention.id
                );
            });
            this.events.push(event);
            event.intervention = intervention;
            return self.InterventionApi.save(intervention, {
                withAsPlanned: true,
            }).then(function (i) {
                let cssClass = i.etat_display.cssClass;
                if (!i.is_planned) {
                    cssClass += " unplanned";
                }
                if (!i.is_as_planned) {
                    cssClass += " not_as_planned";
                }
                if (i.to_notify) {
                    cssClass += " to_notify";
                }
                if (i.controle) {
                    cssClass += " controle";
                }
                if (i.mise_en_place) {
                    cssClass += " mise_en_place";
                }
                event.class = cssClass;
                event.intervention.is_as_planned = i.is_as_planned;

                self.updateDisponibilites();

                return i;
            });
        },
        setPlanningAsDefault() {
            let self = this;
            if (self.savingDefaultPlanning) {
                return;
            } else {
                self.savingDefaultPlanning = true;
            }
            let promises = [];
            let modifiedEvents = self.getModifiedInterventionsEvents();
            _.forEach(modifiedEvents, function (e) {
                self.InterventionApi.updatePlanning(e.intervention.id, {
                    withAsPlanned: true,
                }).then(function (i) {
                    let cssClass = i.etat_display.cssClass;
                    if (!i.is_planned) {
                        cssClass += " unplanned";
                    }
                    if (!i.is_as_planned) {
                        cssClass += " not_as_planned";
                    }
                    e.class = cssClass;
                    e.intervention.is_as_planned = i.is_as_planned;

                    let dateIntervention = moment(i.date_prevue_intervention);
                    let promise =
                        self.RecurrenceInterventionApi.resetInterventionRecurrente(
                            i.recurrence_intervention_id,
                            dateIntervention.add(1, "d").format("DD/MM/YYYY")
                        );
                    promises.push(promise);

                    return i;
                });
            });
            Promise.all(promises).then(function () {
                self.savingDefaultPlanning = false;
            });
        },
        exportCalendrierPdf() {
            let self = this;
            if (self.pdfExporting || !self.dateRange.startDateStr) {
                return;
            }
            let employeIds = [self.selectedEmploye.id];
            if (
                self.secondSelectedEmploye &&
                self.secondSelectedEmploye.id > 0
            ) {
                employeIds.push(self.secondSelectedEmploye.id);
            }
            self.pdfExporting = true;
            self.InterventionApi.openInNewTab(
                self.InterventionApi.getCalendrierPdfUrl(
                    employeIds,
                    self.dateRange.startDateStr
                )
            )
                .catch(function () {
                    swal("L'export du calendrier a échoué", "", "error");
                })
                .finally(function () {
                    self.pdfExporting = false;
                });
        },
        // Selection
        toggleEventSelection(event) {
            event.selected = !event.selected;
            event.class = event.selected ? "selected" : "unselected";
        },
        toggleSelectionMode(type?: string) {
            this.eventSelectionMode = !this.eventSelectionMode;
            if (this.eventSelectionMode) {
                this.reassignType = type;
                _.forEach(this.events, function (e) {
                    e.selected = false;
                    e.class = "unselected";
                });
            } else {
                this.refreshEvents();
            }
        },
        onCellClick(cell) {
            let self = this;
            if (self.eventSelectionMode) {
                let cellDate = moment(cell.date ? cell.date : cell);
                _.chain(this.events)
                    .filter(function (e) {
                        let startDate = moment(e.start, "YYYY-MM-DD HH:mm");
                        return (
                            !e.background && startDate.isSame(cellDate, "day")
                        );
                    })
                    .forEach(function (e) {
                        self.toggleEventSelection(e);
                    })
                    .value();
            }
        },
        onMouseEnter(event) {
            if (
                event.intervention &&
                event.intervention.copied_intervention_id
            ) {
                let copiedIntervention = _.find(this.events, function (e) {
                    return (
                        e.intervention.id ===
                        event.intervention.copied_intervention_id
                    );
                });
                if (copiedIntervention) {
                    copiedIntervention.class += " highlight";
                }
            }
        },
        onMouseLeave(event) {
            if (
                event.intervention &&
                event.intervention.copied_intervention_id
            ) {
                let copiedIntervention = _.find(this.events, function (e) {
                    return (
                        e.intervention.id ===
                        event.intervention.copied_intervention_id
                    );
                });
                if (copiedIntervention) {
                    copiedIntervention.class = copiedIntervention.class.replace(
                        "highlight",
                        ""
                    );
                }
            }
        },
        showReassignationPopup() {
            this.reassignInterventions = _.chain(this.events)
                .filter("selected")
                .map(function (e) {
                    return new Intervention(e.intervention);
                })
                .value();
            if (this.reassignInterventions.length > 0) {
                this.showReassignModal = true;
            } else {
                swal(
                    "Veuillez sélectionner au moins une intervention",
                    "",
                    "error"
                );
            }
        },
        showReassignationDatePopup() {
            this.reassignInterventions = _.chain(this.events)
                .filter("selected")
                .map(function (e) {
                    return new Intervention(e.intervention);
                })
                .value();
            if (this.reassignInterventions.length > 0) {
                this.showReassignDateModal = true;
            } else {
                swal(
                    "Veuillez sélectionner au moins une intervention",
                    "",
                    "error"
                );
            }
        },
        showControlPopup() {
            this.reassignInterventions = _.chain(this.events)
                .filter("selected")
                .map(function (e) {
                    return new Intervention(e.intervention);
                })
                .value();
            if (this.reassignInterventions.length > 0) {
                this.showControlModal = true;
            } else {
                swal(
                    "Veuillez sélectionner au moins une intervention",
                    "",
                    "error"
                );
            }
        },
        showSetupPopup() {
            this.reassignInterventions = _.chain(this.events)
                .filter("selected")
                .map(function (e) {
                    return new Intervention(e.intervention);
                })
                .value();
            if (this.reassignInterventions.length > 0) {
                this.showSetupModal = true;
            } else {
                swal(
                    "Veuillez sélectionner au moins une intervention",
                    "",
                    "error"
                );
            }
        },
        closeReassignationModal() {
            this.showReassignModal = false;
            this.showReassignDateModal = false;
            this.showControlModal = false;
            this.showSetupModal = false;
            this.toggleSelectionMode();
            this.updateDisponibilites();
        },
        createIntervention() {
            this.interventionModal.isNew = true;
        },
        onInterventionModalClose() {
            this.interventionModal.interventionId = null;
            this.interventionModal.forceEditing = false;
            this.interventionModal.isNew = false;
            this.updateDisponibilites();
        },
        // API
        refreshEvents() {
            let self = this;

            self.events = [];
            self.unassignedEvents = [];

            if (!self.selectedEmploye) {
                return;
            }

            self.loading = true;

            let withUnassigned = self.selectedEmploye.id === -1;

            let employeIds = [];
            if (!withUnassigned) {
                employeIds.push(self.selectedEmploye.id);
            }
            if (self.secondSelectedEmploye) {
                employeIds.push(self.secondSelectedEmploye.id);
            }

            let params = {
                // get employe planning
                datePrevueFrom: self.dateRange.startDateStr,
                datePrevueTo: self.dateRange.endDateStr,
                programmed: true,
                employeIds: _.join(employeIds, ","),
                withAsPlanned: true,
                withHorairesSet: true,
                limit: 100000,
            };

            if (withUnassigned) {
                params["emptyEmploye"] = true;
            }

            let promiseA = self.InterventionApi.getAll(params).then(function (
                response
            ) {
                let { data, metadata, paginator } = response;
                _.forEach(data, function (i) {
                    let startTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_debut
                            ? i.horaire_debut.replace("h", ":")
                            : "08:00");
                    let endTimeStr =
                        i.date_prevue_intervention +
                        " " +
                        (i.horaire_fin
                            ? i.horaire_fin.replace("h", ":")
                            : "08:30");
                    let cssClass = i.etat_display.cssClass;
                    if (!i.is_planned) {
                        cssClass += " unplanned";
                    }
                    if (!i.is_as_planned) {
                        cssClass += " not_as_planned";
                    }
                    if (i.to_notify) {
                        cssClass += " to_notify";
                    }
                    if (i.controle) {
                        cssClass += " controle";
                    }
                    if (i.mise_en_place) {
                        cssClass += " mise_en_place";
                    }
                    if (
                        !i.horaire_debut ||
                        !i.horaire_fin ||
                        !i.horaire_debut.match(/\d+h\d+/) ||
                        !i.horaire_fin.match(/\d+h\d+/) ||
                        i.horaire_fin < i.horaire_debut
                    ) {
                        return;
                        cssClass += " anomaly";
                    }
                    let employes = _.intersection(employeIds, i.employes_ids);
                    let split = employes[0];
                    if (withUnassigned && employes.length === 0) {
                        split = -1;
                    }
                    let event = {
                        start: startTimeStr,
                        end: endTimeStr,
                        title: i.client ? i.client.nom : "",
                        content: i.titre,
                        class: cssClass,
                        split: split,
                        intervention: i,
                    };
                    if (i.copied_intervention_id) {
                        event.content =
                            "<i class='copy-icon far fa-clone'></i>";
                    }
                    self.events.push(event);
                    if (employes.length > 1) {
                        let event2 = _.clone(event);
                        event2.split = employes[1];
                        self.events.push(event2);
                    }
                });
                _.each(employeIds, function (eId) {
                    if (eId <= 0) {
                        return;
                    }
                    self.getWorkingHours(eId).then(function (workingHours) {
                        self.events = _.concat(self.events, workingHours);
                    });
                    self.getAbsences(eId).then(function (absences) {
                        self.events = _.concat(self.events, absences);
                    });
                });
            });
            self.updateDisponibilites();
            Promise.all([promiseA]).then(function () {
                self.getHolidays(employeIds);
                self.loading = false;
            });
        },
        getWorkingHours(employe_id: Number) {
            let self = this;

            if (employe_id <= 0) {
                return [];
            }

            return self.EmployeApi.getPlanningByDate(
                employe_id,
                self.dateRange.startDateStr
            ).then(function (planning) {
                return _.map(planning.planning_working_hours, function (wh) {
                    return _.assign(wh.toEvent(self.dateRange.startDateStr), {
                        split: employe_id,
                    });
                });
            });
        },
        getAbsences(employe_id: Number) {
            let self = this;

            if (employe_id <= 0) {
                return [];
            }

            return self.EmployeApi.getAbsences(employe_id).then(function (
                absences
            ) {
                return _.map(absences, function (a) {
                    let start_date = a.date_debut + " 00:00";
                    let end_date =
                        (a.date_fin || self.dateRange.endDateStr) + " 23:59";
                    return {
                        start: start_date,
                        end: end_date,
                        background: true,
                        class: "absence" + (a.is_conge ? " conge" : ""),
                        split: employe_id,
                    };
                });
            });
        },
        getHolidays(employeIds) {
            let self = this;
            self.HolidaysApi.getNext().then(function (holidays) {
                _.each(holidays, function (h) {
                    let date = moment(h).format("YYYY-MM-DD");
                    let event = {
                        start: date,
                        end: date,
                        title: "Jour férié",
                        background: true,
                        class: "holiday",
                        allDay: true,
                        split: employeIds[0],
                    };
                    self.events.push(event);
                    if (employeIds.length > 1) {
                        let event2 = _.clone(event);
                        event2.split = employeIds[1];
                        self.events.push(event2);
                    }
                });
            });
        },
        getModifiedInterventionsEvents() {
            // Interventions
            return _.filter(this.events, function (e) {
                return e.intervention && !e.intervention.is_as_planned;
            });
        },
        updateDisponibilites() {
            let self = this;
            if (self.isSelectedEmploye) {
                self.EmployeApi.get(self.selectedEmploye.id, {
                    withDisponibilites: self.dateRange.week,
                }).then(function (res) {
                    self.disponibilites.employe1 = res.disponibilites;
                });
            }
            if (self.secondSelectedEmploye) {
                self.EmployeApi.get(self.secondSelectedEmploye.id, {
                    withDisponibilites: self.dateRange.week,
                }).then(function (res) {
                    self.disponibilites.employe2 = res.disponibilites;
                });
            }
        },
        // UI
        printDateAndTime(event): string {
            let start = moment(event.start, "YYYY-MM-DD HH:mm");
            let end = moment(event.end, "YYYY-MM-DD HH:mm");
            return (
                start.format("DD/MM/YYYY HH[h]mm") +
                " - " +
                end.format("HH[h]mm")
            );
        },
        disabledViews() {
            if (this.eventSelectionMode) {
                return ["years", "month", "day"];
            } else {
                return ["years"];
            }
        },
    },
    watch: {
        selectedEmploye: function () {
            if (this.selectedEmploye) {
                this.splitDays[0].id = this.selectedEmploye.id;
                this.splitDays[0].label = this.isSelectedEmploye
                    ? this.selectedEmploye.nom
                    : "Non assigné";
                this.splitDays[0].hide = false;
            } else {
                this.secondSelectedEmploye = null;
            }
            this.refreshEvents();
        },
        secondSelectedEmploye: function () {
            if (this.secondSelectedEmploye) {
                this.splitDays[1].id = this.secondSelectedEmploye.id;
                this.splitDays[1].label = this.secondSelectedEmploye.nom;
                this.splitDays[1].hide = false;
                this.stickySplitLabels = true;
            } else {
                this.splitDays[1].hide = true;
                this.stickySplitLabels = false;
            }
            this.refreshEvents();
        },
    },
};
